// 所有页面
export enum PAGE_NAME {
  ROOT = 'Root',
  LOGIN = 'Login',
  Tenant = 'Tenant',
  PAGE_NOT_FOUND = 'PageNotFound',

  NOT_SET = 'NotSet',
  INSIGHT_LIST = 'InsightList',
  Brief = 'Brief',
  Project = 'Project',
  ItemCenter = 'ItemCenter',
  BriefDetail = 'BriefDetail',

  ProjectDetail = 'ProjectDetail',
  ProjectMaterial = 'ProjectMaterial',

  VideoDetail = 'VideoDetail',
}
// 主页
export const PAGE_HOME = PAGE_NAME.INSIGHT_LIST
